/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTileRunStatusRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {GetTileRunStatusResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const getTileRunStatus = (request:GetTileRunStatusRequest, options?: CashRequestOptions) => post<GetTileRunStatusRequest, GetTileRunStatusResponse>("/2.0/cash/get-tile-run-status", request, {...options, rejectOnError: true })